module.exports = __webpack_public_path__ + "img/alb-alert.33d0d678.svg";